import styled from "styled-components";

const Title = styled.label`
  text-align: start;
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const Spacer = styled.div`
  width: 100%;
  border-top: 1px solid white;
  opacity: 12%;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const IconifiedButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: ${(props) => props.theme.padding.content};
  padding-right: ${(props) => props.theme.padding.content};
`;

// button with icon
const IconifiedButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 8px 8px;
  justify-content: center;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;

const IconifiedButtonImage = styled.img`
  width: ${(props) => props.theme.iconSize.medium};
  height: ${(props) => props.theme.iconSize.medium};
  margin-bottom: 16px;
  border-radius: 50%;
`;

const IconifiedButtonTitle = styled.div`
  margin-top: 0;
  font-size: ${(props) => props.theme.font.size.tertiary};
  color: ${(props) => props.theme.color.text.primary};
`;

const IconifiedButton = (props) => (
  <IconifiedButtonContainer onClick={props.onClick}>
    <IconifiedButtonImage src={props.style.icon} />
    <IconifiedButtonTitle>{props.style.title}</IconifiedButtonTitle>
  </IconifiedButtonContainer>
);

export { Title, IconifiedButtonsContainer, Spacer, IconifiedButton };
